import { render, staticRenderFns } from "./UserFastPasswordReset.vue?vue&type=template&id=4655f6a9"
import script from "./UserFastPasswordReset.vue?vue&type=script&lang=js"
export * from "./UserFastPasswordReset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/UserFastPasswordReset.vue
// module id = null
// module chunks = 